import { render, staticRenderFns } from "./NoticeRecord.vue?vue&type=template&id=f67f35e6&scoped=true"
import script from "./NoticeRecord.vue?vue&type=script&lang=js"
export * from "./NoticeRecord.vue?vue&type=script&lang=js"
import style0 from "./NoticeRecord.vue?vue&type=style&index=0&id=f67f35e6&prod&scoped=true&less=true&lang=css"
import style1 from "./NoticeRecord.vue?vue&type=style&index=1&id=f67f35e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f35e6",
  null
  
)

export default component.exports